// extracted by mini-css-extract-plugin
export default {"loader":"loader___GFm4Qz_","visible":"visible___GFm4Qz_","hidden":"hidden___GFm4Qz_","inline":"inline___GFm4Qz_","small":"small___GFm4Qz_"};